import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../../../../app/store";
import axiosInstance from "../../../../../configs/axios/axios ";
import {
  UPLOAD_FILE,
  DELETE_FILE,
} from "../../../../../configs/axios/constantsAPI";
import {
  getDirectoryAction,
  searchDirectoryAction,
} from "../../directory/directorySlice";
import { getAlternativeFileAction } from "../../drawer/drawer-item/drawer-share/alternative-file-modal/alternativeFileModalSlice";
import { getCookie } from "../../../../../configs/cookie-helper/cookieHelper";

const CancelToken = axios.CancelToken;
let cancel: any;

export const uploadFileAction = createAsyncThunk(
  "uploadFile/uploadFile",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        UPLOAD_FILE,
        sendData.formData,
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
          onUploadProgress: (progressEvent: any) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            if (percentCompleted < 99) {
              sendData.setUploadPercentage(percentCompleted);
            }
          },
          cancelToken: new CancelToken((c) => {
            cancel = c;
          }),
        }
      );

      dispatch(
        getDirectoryAction({
          path: getState().directoryState.directoryData.path,
          idfolder: getState().directoryState.directoryData.idfolder,
        })
      );
      dispatch(getAlternativeFileAction());

      return data;
    } catch (error: any) {
      console.log(error);

      if (error?.message === "Network Error") {
        return rejectWithValue(error);
      }

      if (axios.isCancel(error)) {
        return rejectWithValue(error.message);
      }

      if (!error.response) {
        return rejectWithValue(error.response.data);
      }
    }
  }
);

export const deleteFileAction = createAsyncThunk(
  "uploadFile/deleteFile",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        DELETE_FILE,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      dispatch(
        getDirectoryAction({
          path: getState().directoryState.directoryData.path,
          idfolder: getState().directoryState.directoryData.idfolder,
        })
      );

      if (getState().directoryState.searchInput !== "") {
        dispatch(
          searchDirectoryAction({
            path: getState().directoryState.directoryData.path,
            name: getState().directoryState.searchInput,
            dir: "true",
          })
        );
      }

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export interface UploadFileState {
  uploadFileData: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
  };
  openModal: boolean;
}

const initialState: UploadFileState = {
  uploadFileData: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
  },
  openModal: false,
};

export const uploadFileSlice = createSlice({
  name: "uploadFile",
  initialState,
  reducers: {
    uploadFileOpenAction: (state) => {
      state.openModal = true;
    },
    uploadFileCloseAction: (state) => {
      state.openModal = false;
    },
    cancelUploadFileAction: (state, action: PayloadAction<string>) => {
      cancel(action.payload);
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(uploadFileAction.pending, (state) => {
      state.uploadFileData.actionStatus = "loading";
      state.uploadFileData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(uploadFileAction.fulfilled, (state, { payload }) => {
      state.uploadFileData.actionStatus = "success";
      state.uploadFileData.alert = {
        error: payload?.content?.error,
        message: payload?.content?.message,
      };
    });
    addCase(uploadFileAction.rejected, (state, { payload }: any) => {
      state.uploadFileData.actionStatus = "rejected";
      state.uploadFileData.alert = {
        error:
          payload?.content?.error || payload === "Your system is offlined."
            ? true
            : false,
        message: payload?.content?.message ? payload.content.message : payload,
      };
    });
  },
});

export const {
  uploadFileOpenAction,
  uploadFileCloseAction,
  cancelUploadFileAction,
} = uploadFileSlice.actions;

export const uploadFile = (state: RootState) => state.uploadFileState;

export default uploadFileSlice.reducer;
